import React, { useEffect } from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useUserData from "../../../../hooks/user/useUserData";
import { facebook, instagram } from "../../../../assets/social/socialIcons";
import { FOOTER } from "../../../../locales/components/namespaces";

const FooterContactSection = () => {
  const { t, i18n } = useTranslation(FOOTER);
  const { language } = useUserData();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  return (
    <Box
      sx={{
        minWidth: 0,
      }}
    >
      <Typography
        variant="overline"
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: "0.1em",
          fontFamily: "'Roboto Condensed', Arial, sans-serif",
          mb: 2,
          display: "block",
          lineHeight: "90%",
        })}
      >
        {t("contact")}
      </Typography>

      <Stack spacing={2}>
        <Typography
          variant="body2"
          sx={{
            fontSize: 14,
            fontWeight: "900",
            lineHeight: "120%",
            color: "#111111",
            fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
          }}
        >
          <Box
            component="span"
            sx={{
              fontWeight: 900,
              fontSize: 14,
              fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
            }}
          >
            {t("company_name")}
          </Box>
          <br />
          <Box
            component="span"
            sx={{
              fontWeight: 500,
              fontSize: 14,
              fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
            }}
          >
            {t("company_address_1")}
            <br />
            {t("company_address_2")}
          </Box>
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: 13, md: 14 },
            lineHeight: "100%",
            fontWeight: 900,
            color: "#111111",
            fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
            letterSpacing: "0",
          }}
        >
          +30 2144001600
          <br />
          <Link
            href="mailto:sales@brewspecialists.gr"
            sx={{
              color: "#111111",
              textDecoration: "underline",
              fontWeight: 900,
            }}
          >
            sales@brewspecialists.gr
          </Link>
        </Typography>

        <Stack direction="row" spacing={1.5}>
          {[facebook, instagram].map((icon, idx) => (
            <Box
              key={idx}
              sx={{
                width: { xs: "36px", md: "40.9px" },
                height: { xs: "36px", md: "40.9px" },
                bgcolor: "#fff",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1.5px solid #D8D8D8",
                cursor: "pointer",
                "&:hover": { borderColor: "#111111" },
              }}
            >
              <img
                src={icon}
                alt={idx === 0 ? "Facebook" : "Instagram"}
                style={{
                  width: "20px",
                  height: "20px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default FooterContactSection;
